import { getIdToken } from "./authService"


export default class ApiClientOptions {
	/**
	 * Returns a valid value for the Authorization header.
	 * Used to dynamically inject the current auth header.
	 */
	getAuthorization = () => getIdToken();
}